const state = {
  deviceList: {
    content: [],
    count: 0,
  },
  divList: {
    content: [],
    count: 0,
  },
  plans: {
    content: [],
    count: 0,
  },
  telecomList: {
    content: [],
    count: 0,
  },
  nicknameList: {
    content: [],
    count: 0,
  },
};

export default state;
